import React from 'react';

const GlobalsContext = React.createContext();

export default GlobalsContext